import React, { Fragment, useContext, useEffect, useState } from "react";
import { MdSave, MdCancel, MdUpload } from "react-icons/md";
import notifyContext from "../../../../../Context/notifyContext";
import { save, findOne } from "../../../../../../services/Client__Service";
import navContext from "../../../../../Context/navContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../../Loader/Loader";
import { getfile } from "../../../../../../services/Document__Servive";
import { SIZE_IMAGE_UPLOAD } from "../../../../../../services/config";
import { FORMER_JURIDIQUE } from "../../../../../../services/Constante";
import PhoneNumber from "../../../../../PhoneNumber/PhoneNumber";
const Form = ({ clientId = 0, view = false }) => {
  const paramsRoute = useParams();

  const notify = useContext(notifyContext);
  const redirect = useNavigate();
  const [id, setId] = useState(
    clientId !== 0
      ? clientId
      : paramsRoute.id === undefined
      ? 0
      : paramsRoute.id
  );
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [client, setClient] = useState({
    id: 0,
    sigle: "",
    nom: "",
    email1: "",
    email2: "",
    tel1: "",
    tel2: "",
    nif: "",
    rccm: "",
    pays: 0,
    ville: "",
    adresse: "",
    statut: 1,
    formeJuridique: "",
  });
  const nav = useContext(navContext);

  useEffect(() => {
    if (paramsRoute["*"] === "edit" && id === 0) redirect("/main/client");

    let nextValue = "";

    if (id === 0) {
      nextValue = "Nouveau";
    } else {
      if (client.id !== 0) nextValue = client.nom;
    }

    !view &&
      nav({
        links: [
          {
            href: "/main/client",
            linkname: "Clients",
          },
          {
            href: "",
            linkname: nextValue,
          },
        ],
        children: "",
      });
  }, [client]);

  useEffect(() => {
    if (id !== undefined && id > 0) {
      setIsLoading(true);
      fetchOneClient(id);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (client.sigle === "") {
      display_errors.push({
        message: "Veuillez entrer le sigle",
        id_input: "sigle",
      });
    }

    if (client.nom === "") {
      display_errors.push({
        message: "Veuillez entrer le nom",
        id_input: "nom",
      });
    }
    if (client.email1 === "") {
      display_errors.push({
        message: "Veuillez entrer l'email 1",
        id_input: "email1",
      });
    }

    if (client.tel1 === "") {
      display_errors.push({
        message: "Veuillez entrer le teléphone 1",
        id_input: "tel1",
      });
    }

    if (parseInt(client.statut) < 0 || parseInt(client.statut) > 1) {
      display_errors.push({
        message: "Veuillez sélectionner un statut",
        id_input: "statut",
      });
    }

    if (isFilePicked) {
      if (!selectedFile.type.includes("image/")) {
        display_errors.push({
          message: "Type de fichier incorrect. (Image autorisé)",
          id_input: "logo",
        });
      } else if (selectedFile.size > SIZE_IMAGE_UPLOAD) {
        display_errors.push({
          message:
            "Taille de fichier très grand (taille ne doit pas dépasser 1Mo)",
          id_input: "logo",
        });
      }
    }

    display_errors.map(({ message, id_input }, key) => {
      return (
        <label key={key} htmlFor={id_input}>
          {message}
        </label>
      );
    });

    setError(
      display_errors.map(({ message, id_input }, key) => {
        return (
          <label key={key} htmlFor={id_input}>
            {message}
          </label>
        );
      })
    );

    if (display_errors.length === 0) {
      setIsSend(true);
      save(
        isFilePicked
          ? { ...client, logo: selectedFile }
          : { ...client, logo: undefined }
      )
        .then((response) => {
          setIsSend(false);
          if (client.id === 0) {
            notify("Enregistré avec succès", "success");
          } else {
            notify("Modifié avec succès", "success");
          }
          redirect("/main/client");
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setClient((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };

  const fetchOneClient = async (idParams) => {
    findOne(idParams)
      .then((response) => {
        setClient(response.data);
        fecthFile(response.data.logo);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }

        redirect("/main/client");
      });
  };

  const fecthFile = async (logo) => {
    getfile(logo, "image")
      .then((response) => {
        setSelectedFile(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  /* FILE HANDLE */
  const [selectedFile, setSelectedFile] = useState(null); // contient des informations sur le fichier actuellement sélectionné.
  const [isFilePicked, setIsFilePicked] = useState(false); //détermine si un fichier a été sélectionné ou non.

  const handleChangeFile = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    }
  };

  /* FILE HANDLE END */
  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);
  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        {!view && (
          <div className="form-header">
            <small>
              Les champs comportant <span className="required">*</span> sont
              obligatoires
            </small>
            <div className="error">{error}</div>
          </div>
        )}

        <div className="form-body">
          <div className="form-group">
            <label htmlFor="nom" className="form-label">
              Nom <span className="required">*</span> :
            </label>
            <input
              type="text"
              name="nom"
              id="nom"
              className="form-input"
              value={client.nom}
              onChange={handleChange}
              readOnly={view}
            />
          </div>
          <div className="form-group">
            <label htmlFor="sigle" className="form-label">
              Sigle <span className="required">*</span> :
            </label>
            <input
              type="text"
              name="sigle"
              id="sigle"
              className="form-input"
              value={client.sigle}
              onChange={handleChange}
              readOnly={view}
            />
          </div>
          <div className="form-group">
            <label htmlFor="email1" className="form-label">
              Email 1 <span className="required">*</span> :
            </label>
            <input
              type="email"
              name="email1"
              id="email1"
              className="form-input"
              value={client.email1}
              onChange={handleChange}
              readOnly={view}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email2" className="form-label">
              Email 2 :
            </label>
            <input
              type="email"
              name="email2"
              id="email2"
              className="form-input"
              value={client.email2}
              onChange={handleChange}
              readOnly={view}
            />
          </div>
          <div className="form-group">
            <label htmlFor="tel1" className="form-label">
              Téléphone 1 <span className="required">*</span> :
            </label>
            <PhoneNumber
              name="tel1"
              id="tel1"
              state={client.tel1}
              setState={setClient}
              readOnly={view}
            />
          </div>
          <div className="form-group">
            <label htmlFor="tel2" className="form-label">
              Téléphone 2 :
            </label>
            <PhoneNumber
              name="tel2"
              id="tel2"
              state={client.tel2}
              setState={setClient}
              readOnly={view}
            />
          </div>

          <div className="form-group">
            <label htmlFor="statut" className="form-label">
              Statut <span className="required">*</span> :
            </label>
            <select
              name="statut"
              id="statut"
              defaultChecked={1}
              className="form-select"
              value={client.statut}
              onChange={handleChange}
              disabled={view}
            >
              <option value="1">Actif</option>
              <option value="0">Inactif</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="nif" className="form-label">
              NIF :
            </label>
            <input
              type="text"
              name="nif"
              id="nif"
              className="form-input"
              value={client.nif}
              onChange={handleChange}
              readOnly={view}
            />
          </div>
          <div className="form-group">
            <label htmlFor="rccm" className="form-label">
              RCCM :
            </label>
            <input
              type="text"
              name="rccm"
              id="rccm"
              className="form-input"
              value={client.rccm}
              onChange={handleChange}
              readOnly={view}
            />
          </div>
          <div className="form-group">
            <label htmlFor="pays" className="form-label">
              Pays :
            </label>
            <select
              name="pays"
              id="pays"
              defaultChecked={1}
              className="form-select"
              value={client.pays}
              onChange={handleChange}
              disabled={view}
            >
              <option value="0" disabled>
                Sélectionner un pays
              </option>
              <option value="1">Cameroun</option>
              <option value="2">Gabon</option>
              <option value="3">Congo</option>
              <option value="4">Tchad</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="ville" className="form-label">
              Ville :
            </label>
            <input
              type="text"
              name="ville"
              id="ville"
              className="form-input"
              value={client.ville}
              onChange={handleChange}
              readOnly={view}
            />
          </div>
          <div className="form-group">
            <label htmlFor="adresse" className="form-label">
              Adresse :
            </label>
            <textarea
              name="adresse"
              id="adresse"
              cols="50"
              rows="100"
              className="form-text-area"
              value={client.adresse}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            ></textarea>
          </div>

          <div className="form-group">
            <label htmlFor="formeJuridique" className="form-label">
              Forme Juridique :
            </label>
            <select
              name="formeJuridique"
              id="formeJuridique"
              className="form-select"
              value={client.formeJuridique}
              onChange={handleChange}
              disabled={view}
            >
              <option value="">Sélectionner une forme Juridique</option>
              {FORMER_JURIDIQUE.map((elt, key) => {
                return (
                  <option key={key} value={elt}>
                    {elt}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="form-group previewImg">
          <label htmlFor="logo" className="form-label">
            Logo :
          </label>
          <input
            style={{
              display: "none",
            }}
            type="file"
            name="logo"
            id={!view ? "logo" : ""}
            className="form-input-file"
            onChange={handleChangeFile}
            accept="image/*"
            readOnly={view}
          />
          <label htmlFor="logo" className="previewImg__content">
            {selectedFile && (
              <img src={URL.createObjectURL(selectedFile)} alt="logo client" />
            )}
          </label>
          <label htmlFor="logo" className="form-label btn">
            <MdUpload />
          </label>
        </div>

        {!view && (
          <div className="form-footer">
            <button type="submit" className="btn">
              <MdSave />
              Enregistrer
            </button>
            <button type="reset" className="btn btn--outline">
              <Link to="/main/client">
                <MdCancel />
                Annuler
              </Link>
            </button>
          </div>
        )}
      </form>
      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </Fragment>
  );
};

export default Form;
